<div class="table-responsive mt-4">
  <table class="table table-sm align-middle">
    <thead>
      <tr>
        <th>Jornada</th>
        <th>Padrao</th>
        <th>Tolerancia</th>
        <th>Horarios</th>
        <th>Status</th>
        <th class="text-end">Acao</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of jornadas">
        <td>{{ item.nome }}</td>
        <td>{{ item.padrao ? 'Sim' : 'Nao' }}</td>
        <td>{{ item.validarJanelaPonto ? item.toleranciaMinutos + ' min' : 'Livre' }}</td>
        <td>{{ item.horarios.length }}</td>
        <td>{{ item.ativa ? 'Ativa' : 'Inativa' }}</td>
        <td class="text-end">
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="selecionar.emit(item.id || '')">
            <i class="bi bi-pencil-square"></i>
          </button>
        </td>
      </tr>
      <tr *ngIf="jornadas.length === 0">
        <td colspan="6" class="text-secondary text-center">Nenhuma jornada cadastrada.</td>
      </tr>
    </tbody>
  </table>
</div>
